import React from "react";
import { Button } from "@mui/material";
import { PowerSettingsNew } from "@mui/icons-material";

const ToggleButton = ({ on, onClick }) => {
  return (
    <Button
      variant="contained"
      color={on ? "primary" : "secondary"}
      onClick={onClick}
      startIcon={<PowerSettingsNew />}
      sx={{ minWidth: 120 }}
    >
      {on ? "Hold" : "Un Hold"}
    </Button>
  );
};

export default ToggleButton;